<template>
    <h3 v-if="text">
        {{bookingStatusText}}
        <img :src="image" :style="{width: size, height: size}" />
    </h3>
    <img v-else :src="image" :style="{width: size, height: size}" />
</template>

<script>
export default {
    name: 'zoezi-booking-status',

    props: {
        space: {
            type: Number
        },
        spaceLeft: {
            type: Number
        },
        firstBookingTime: {
        },
        lastBookingTime: {
        },
        size: {
            type: String,
            default: '30px'
        },
        text: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        key() {
            let key = 'available';
            // cancelled
            // coming
            // few-spots
            // full

            if (this.firstBookingTime && this.firstBookingTime > this.$store.state.now30s) {
                key = 'coming';
            } else if (this.lastBookingTime && this.lastBookingTime < this.$store.state.now30s) {
                key = 'cancelled';
            } else if (this.spaceLeft === 0) {
                key = 'full'
            } else if (this.spaceLeft && this.space && ((this.spaceLeft/this.space) < 0.20 || this.spaceLeft < 3)) {
                key = 'few-spots';
            }
            return key;
        },
        image() {
            return this.$api.getImageUrl(`/assets/img/booking-status/booking-${this.key}.svg`);
        },
        bookingStatusText() {
            if (this.key == 'coming') {
                const at = window.$store.state.language == 'sv' ? 'den' : '';
                return `${this.$translate('The booking opens')} ${(this.firstBookingTime.isToday() || this.firstBookingTime.isTomorrow()) ? '' : at} ${Date.formatTimeRelative(this.firstBookingTime)} ${this.firstBookingTime.getFullYear() == new Date().getFullYear() ? '' : this.firstBookingTime.getFullYear()}`;
            }
            if (this.key == 'cancelled') {
                return this.$translate('The booking is closed');
            }
            if (this.key == 'full') {
                return this.$translate('Fully booked');
            }

            let res = `${this.$translate('Booking closes')} ${Date.formatTimeRelative(this.lastBookingTime)}`;
            if (this.key == 'few-spots') {
                res += ', ' + this.$translate('few places left');
            }

            return res;
        }
    }
}
</script>
